export enum ReportCategory {
  Spam = 'SPAM',
  Impersonation = 'IMPERSONATION',
  Harassment = 'HARASSMENT',
  Other = 'OTHER',
}
